import axios from 'axios';
import Vuex from 'vuex';
import orders from './store/orders'
import order from './store/order'
import users from './store/users'
import app from './store/app'
import user from './store/user'
import help from './store/help'
import helpMenu from './store/helpMenu'
import faq from './store/faq'
import positions from './store/positions'
import notify from './store/notify'
import history from './store/history'

export default new Vuex.Store({
    state: {
        isAuth: null,
        user: {},
        errorRequest: false,
        error: false,
        sessid: '',
        lang: 'en'
    },
    mutations: {
        SET_SESSID(state, sessid) {
            state.sessid = sessid
        },
        Auth(state, data) {
            if (data.sessid) {
                state.sessid = data.sessid
            }
            if (data.ID) {
                state.isAuth = true;
                state.user = {
                    id: data.ID,
                    admin: data.ADMIN,
                    login: data.LOGIN,
                    fio: data.fio,
                    phone: data.PHONE,
                    email: data.EMAIL,
                    role: data.ROLE,
                    role_name: data.ROLE_NAME
                }
                state.lang = data.lang;
            }
            else
                state.isAuth = false;
        },
        Uuid(state, data) {
            state.uuid = data
        },
        logout(state) {
            state.isAuth = false;
            state.user = {}
        },
        setError(state, data) {
            state.errorRequest = true;
            state.error = data;
        },
        setLang(state, lang) {
            state.lang = lang;
        }
    },
    actions: {
        async Auth({commit, dispatch}, data) {
            commit('Auth', data);
            try {
                if (typeof window.FirebasePlugin != 'undefined') {
                    if (!window.FirebasePlugin.hasPermission()) {
                        window.FirebasePlugin.grantPermission(function () {
                            window.FirebasePlugin.getToken(async function (device_token) {
                                axios.post('api/token/', {
                                    uuid: data.uuid,
                                    token: device_token,
                                    device: data.device
                                });
                            }, function (error) {
                                //alert('error')
                            });
                        }, function (error) {
                            //alert(error);
                        });
                    }
                    window.FirebasePlugin.getToken(async function (device_token) {
                        axios.post('api/token/', {
                            uuid: data.uuid,
                            token: device_token,
                            device: data.device
                        },{
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }});
                    }, function (error) {
                        //alert('error')
                    });
                }
            }
            catch (err) {
                let form = new FormData();
                form.append("useragent", window.navigator.userAgent)
                form.append("date", new Date());
                form.append("error", err);
                /*let response = fetch('https://mcbuy.mobileapp.alm.su/api/log/', {
                    method: 'POST',
                    body: form
                });*/
                axios.post('api/log/', form,{
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }});
            }
        },

        AuthRepeat({commit, dispatch}, data) {
            commit('Auth', data);
        },
        async logout({commit, dispatch, state}) {
            await axios.post('api/user/logout/', {uuid: state.device_uuid},
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
            commit('logout');
        },
        async setLang({commit, dispatch, state}, lang) {
            await axios.post('api/user/lang/', {lang: lang},
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
            commit('setLang', lang);
        },
        async setError({commit, dispatch}, data) {
            commit('setError', data);
        }
    },
    getters: {
        sessid: s => s.sessid,
        isAuth: s => s.isAuth,
        user: s => s.user,
        lang: s => s.lang,
        errorRequest: s => s.errorRequest
    },
    modules: {
        orders,
        users,
        app,
        user,
        help,
        helpMenu,
        faq,
        order,
        positions,
        notify,
        history
    }
})
